module.exports = __webpack_public_path__ + "static/media/210-Mitpatient_ID_17.507e18f4.mp3";